{
  "header": "{{firstName}}, we need to verify your identity",
  "button": "Continue",
  "inputs": {
    "full-ssn": {
      "label": "Social Security Number",
      "isRequired": true,
      "showRequiredIcon": true,
      "placeholder": "***-**-****",
      "mask": "000-00-0000",
      "allowHide": true,
      "allowHideLabel": "Show your full SSN",
      "tooltip": "<div><span>We need this to verify</span><br><span>your identity.</span></div>",
      "validity": [
        ["required", "Social Security Number is required", "ignore-label"],
        ["requiredLength9", "Social Security Number is invalid", "ignore-label"]
      ],
      "postProcess": "digitOnlyString"
    }
  }
}
